import React from 'react';
import { exportToPDF, exportToExcel } from '../utils/exportReports';

export default function StatsPage({ locations, activityLogs }) {
  const totalLocations = locations.length;
  const totalFiles = locations.length * 5;
  const totalStorage = locations.length * 500;

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'2rem'}}>
        <h2 style={{color:'#1e3c72'}}>📊 Estadísticas</h2>
        <div style={{display:'flex',gap:'1rem'}}>
          <button
            onClick={() => exportToPDF(locations, activityLogs)}
            style={{background:'#dc3545',color:'white',padding:'0.7rem 1.5rem',border:'none',borderRadius:'4px',cursor:'pointer',fontWeight:'600'}}
          >
            📄 Exportar PDF
          </button>
          <button
            onClick={() => exportToExcel(locations, activityLogs)}
            style={{background:'#28a745',color:'white',padding:'0.7rem 1.5rem',border:'none',borderRadius:'4px',cursor:'pointer',fontWeight:'600'}}
          >
            📊 Exportar Excel
          </button>
        </div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit, minmax(250px, 1fr))',gap:'1.5rem',marginBottom:'2rem'}}>
        <div style={{background:'white',padding:'1.5rem',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0, 0, 0, 0.05)',borderLeft:'4px solid #2a5298'}}>
          <h3 style={{color:'#6c757d',fontSize:'0.9rem',marginBottom:'0.5rem'}}>📍 Ubicaciones</h3>
          <div style={{fontSize:'2.5rem',fontWeight:'700',color:'#1e3c72'}}>{totalLocations}</div>
        </div>
        <div style={{background:'white',padding:'1.5rem',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0, 0, 0, 0.05)',borderLeft:'4px solid #2a5298'}}>
          <h3 style={{color:'#6c757d',fontSize:'0.9rem',marginBottom:'0.5rem'}}>📄 Total Archivos</h3>
          <div style={{fontSize:'2.5rem',fontWeight:'700',color:'#1e3c72'}}>{totalFiles}</div>
        </div>
        <div style={{background:'white',padding:'1.5rem',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0, 0, 0, 0.05)',borderLeft:'4px solid #2a5298'}}>
          <h3 style={{color:'#6c757d',fontSize:'0.9rem',marginBottom:'0.5rem'}}>💾 Almacenamiento</h3>
          <div style={{fontSize:'2.5rem',fontWeight:'700',color:'#1e3c72'}}>{totalStorage} MB</div>
        </div>
      </div>

      <div style={{background:'white',padding:'1.5rem',borderRadius:'8px'}}>
        <h3 style={{color:'#1e3c72',marginBottom:'1rem'}}>🔔 Historial de Actividad</h3>
        {activityLogs.length === 0 ? (
          <p>No hay actividad</p>
        ) : (
          activityLogs.map((log) => (
            <div key={log.id} style={{padding:'0.5rem',borderLeft:'3px solid #2a5298',marginBottom:'0.5rem'}}>
              <div style={{color:'#1e3c72',fontWeight:'600'}}>{log.action}</div>
              <div style={{color:'#6c757d',fontSize:'0.9rem'}}>📍 {log.location}</div>
              <div style={{color:'#adb5bd',fontSize:'0.8rem'}}>⏰ {log.timestamp}</div>
            </div>
          ))
        )}
      </div>

      <div style={{marginTop:'2rem',padding:'1.5rem',background:'#f0f4ff',borderRadius:'8px'}}>
        <h3 style={{color:'#1e3c72',marginBottom:'1rem'}}>📋 Resumen por Ubicación</h3>
        <table style={{width:'100%',borderCollapse:'collapse'}}>
          <thead>
            <tr style={{background:'#f8f9fa',borderBottom:'2px solid #dee2e6'}}>
              <th style={{padding:'1rem',textAlign:'left',color:'#495057',fontWeight:'600'}}>Ubicación</th>
              <th style={{padding:'1rem',textAlign:'left',color:'#495057',fontWeight:'600'}}>Archivos</th>
              <th style={{padding:'1rem',textAlign:'left',color:'#495057',fontWeight:'600'}}>Almacenamiento</th>
              <th style={{padding:'1rem',textAlign:'left',color:'#495057',fontWeight:'600'}}>Descripción</th>
            </tr>
          </thead>
          <tbody>
            {locations.map((loc) => (
              <tr key={loc.id} style={{borderBottom:'1px solid #e9ecef'}}>
                <td style={{padding:'1rem',color:'#1e3c72',fontWeight:'600'}}>{loc.name}</td>
                <td style={{padding:'1rem'}}>5 / 5</td>
                <td style={{padding:'1rem'}}>500 MB / 500 MB</td>
                <td style={{padding:'1rem',color:'#6c757d'}}>{loc.description || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
